export const TYPE_WIDTH = 2 // UInt16
export const LEDGER_ENTRY_WIDTH = 2 // UInt16
export const TRANSACTION_TYPE_WIDTH = 2 // UInt16
export const TRANSACTION_RESULT_WIDTH = 1 // UInt8
export const DELEGATABLE_PERMISSIONS_WIDTH = 4 // UInt32
